import { formatLocation } from './address'
import { placeAddressParts } from './location'

/**
 * Convert Google place details (from LocationSearch) to charity location attributes.
 * @param {object | null | undefined} place
 * @returns {object | null}
 */
export function parseGooglePlaceToCharityLocation(place) {
  if (!place) return null

  const defaultAddress = place.description

  return {
    name: defaultAddress,
    formatted_address: defaultAddress,
    ...placeAddressParts(place),
    latitude: Number.parseFloat(place.geometry.location.lat),
    longitude: Number.parseFloat(place.geometry.location.lng),
    google_location_id: place.place_id,
    google_description: defaultAddress,
  }
}

/**
 * Strip a location object to PATCH-permitted attributes.
 * @param {object | null | undefined} location
 * @returns {object | null}
 */
export function charityLocationPayload(location) {
  if (!location) return null
  return {
    name: location.name,
    formatted_address: location.formatted_address,
    city: location.city,
    state: location.state,
    zip: location.zip,
    latitude: location.latitude,
    longitude: location.longitude,
    google_location_id: location.google_location_id,
    google_description: location.google_description,
  }
}

/**
 * Compare two charity locations for equality (by google id + formatted address).
 * @param {object | null | undefined} a
 * @param {object | null | undefined} b
 * @returns {boolean}
 */
export function charityLocationsEqual(a, b) {
  if (!a && !b) return true
  if (!a || !b) return false
  return (
    a.google_location_id === b.google_location_id &&
    a.formatted_address === b.formatted_address
  )
}

/**
 * Format a charity location for LocationSearch display value.
 * @param {object | null | undefined} location
 * @returns {string}
 */
export function formatCharityLocationDisplay(location) {
  return formatLocation(location)
}

export const CHARITY_LOCATION_TYPES = [
  { key: 'volunteer_location', stateKey: 'volunteer' },
  { key: 'donation_location', stateKey: 'donation' },
  { key: 'visitor_location', stateKey: 'visitor' },
]
